<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { HTMLButtonAttributes } from 'svelte/elements';

	import { goto } from '$app/navigation';

	import Spinner from './Spinner.svelte';

	const {
		isLoading,
		children,
		outline = false,
		...rest
	}: HTMLButtonAttributes & {
		isLoading?: boolean;
		href?: string;
		outline?: boolean;
		children: Snippet;
	} = $props();
</script>

<button
	disabled={isLoading}
	{...rest}
	onclick={(event) => {
		if (rest?.onclick) return rest.onclick(event);

		if (rest?.href) goto(rest.href);
	}}
	class={[
		'flex cursor-pointer items-center justify-center gap-2 rounded-md border border-black px-6 py-2 text-center font-bold uppercase transition duration-300 disabled:cursor-not-allowed disabled:border-neutral-700',
		outline
			? 'bg-white text-black hover:bg-neutral-900 hover:text-white disabled:bg-neutral-300 disabled:text-neutral-700'
			: 'bg-neutral-900 text-white hover:bg-white hover:text-black disabled:bg-neutral-700 disabled:text-neutral-300',

		rest.class,
	]}
>
	<span>{@render children()}</span>
	{#if isLoading}
		<div class="h-5">
			<Spinner />
		</div>
	{/if}
</button>
